import { LogoProps } from "@/common/types";

export default function Logo({ width }: LogoProps) {
  return (
    <img
      src="/images/Xone.png"
      width={width ? width : "auto"}
      alt="airx logo"
      className="mx-auto w-[210px]"
    />
  );
}
